/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import {convertSvgToDataUri} from '@ion/core/src/utils/Encoding';
import {dlsColor} from '@ion/dls/src/theme/theme';

export interface BatteryEventMarker {
  size?: number,
  containerColor?: string,
  fillColor?: string
};

/**
 * Utility function that returns an image from SVG that can be passed
 * to the esri Graphic constructor to make a graphic for battery events of the asset
 *
 * ```typescript
 *  import {getBatteryEventMarker} from '@ion/dls/src/maps/markers';
 *
 *  return {
 *    type   : 'picture-marker',
 *    url    : getBatteryEventMarker({size, containerColor, fillColor}),
 *    width  : size,
 *    height : size,
 *    angle  : 0
 * }
 * ```
 */
export const getBatteryEventMarker = ({
  fillColor = dlsColor('black'),
  containerColor = dlsColor('white'),
  size = 24
}: BatteryEventMarker) => {
  const svg = (`
    <svg width='${size}' height='${size}' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path fill-rule='evenodd' clip-rule='evenodd' d='M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C23.9927 5.37563 18.6244 0.00734817 12 0Z' fill='#BDBDBD'/>
      <path fill-rule='evenodd' clip-rule='evenodd' d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2.00619 17.5203 6.47972 21.9938 12 22V22Z' fill='${containerColor}'/>
      <g clip-path='url(#clip0_12526_716)'>
        <path d='M12.6 12.901H11.3V9.00098H12.6V12.901ZM12.6 15.601H11.3V14.301H12.6V15.601ZM15.1 6.30098H14V5.00098H10V6.30098H8.9C8.4 6.30098 8 6.70098 8 7.20098V17.301C8 17.801 8.4 18.201 8.9 18.201H15C15.5 18.201 15.9 17.801 15.9 17.301V7.20098C15.9 6.70098 15.5 6.30098 15.1 6.30098Z' fill='${fillColor}'/>
      </g>
      <defs>
        <clipPath id='clip0_12526_716'>
          <rect width='7.9' height='13.2' fill='${containerColor}' transform='translate(8 5.00098)'/>
        </clipPath>
      </defs>
    </svg>
  `);
  return convertSvgToDataUri(svg.trim());
};

export default getBatteryEventMarker;
